export const phoneNumber = '';
export const defaultLogin = '';
export const defaultPassword = '';
export const defaultFetchDelay = 10000;
